import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const titles = {
  '/extra': ' | Extras',
  '/seats': ' | Seat Selection',
  '/checkout': ' | Check Out',
  '/confirmation': ' | Confirmation',
  '/mmb/summary': ' | Manage My Booking',
};

const PageTitle = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    let key;
    for (key in titles) {
      if (location.pathname.endsWith(key)) {
        document.title = title + titles[key];
        return;
      }
    }
    document.title = title;
  }, [location, title]);

  return null;
};

export default PageTitle;
